import axios from 'axios'
import axiosRetry from 'axios-retry'

// https://github.com/softonic/axios-retry/issues/87
const retryDelay = (retryNumber = 0) => {
  const seconds = Math.pow(2, retryNumber) * 1000
  const randomMs = 1000 * Math.random()
  return seconds + randomMs
}

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

axiosRetry(client, {
  retries: 2,
  retryDelay,
  // retry on Network Error & 5xx responses
  retryCondition: axiosRetry.isRetryableError
})

export default client
